export default "__VITE_ASSET__CeJPzcLy__"